import { useReveal } from "../hooks/useReveal";
import { ParallaxBg } from "../components/ParallaxBg";
import { TAKEAWAYS } from "../lib/copy";

export default function Takeaways() {
  const ref = useReveal();
  return (
    <section ref={ref} className="relative overflow-hidden py-28 md:py-36" style={{ background: "rgba(255,255,255,0.015)" }} data-testid="takeaways-section">
      <ParallaxBg image="/bg/home1.jpg" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12">
        <p className="section-label mb-8 reveal-up">[007] — TAKEAWAYS</p>
        <h2 className="reveal-up font-black uppercase mb-14" style={{ fontSize: "clamp(28px, 3.6vw, 48px)", letterSpacing: "-0.02em" }}>
          WHAT YOU'LL WALK AWAY WITH
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {TAKEAWAYS.map((t, i) => (
            <div key={i} className="takeaway-card reveal-up" data-testid={`takeaway-card-${i + 1}`}>
              <i className={`${t.icon} mb-5 block`}></i>
              <h3 className="font-bold mb-3 text-sm uppercase tracking-wide">{t.title}</h3>
              <p className="text-sm" style={{ color: "var(--muted)", lineHeight: 1.7 }}>{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
